<template>
  <v-container>
    <v-layout row wrap></v-layout>
    <iframe
      :src="src"
      ref="pdf"
      target="_blank"
      frameborder="0"
      style="
        overflow: hidden;
        overflow-x: hidden;
        overflow-y: hidden;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
      "
      height="100%"
      width="100%"
    ></iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
//import jsPDF from "jspdf";
import { mapActions } from "vuex";
import pdf from "vue-pdf";
import moment from "moment";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import SettingService from "@/services/SettingService";
import PayrollService from "@/services/PayrollService";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      doc: "",
      src: "",
      ltdName: "",
      empcode: "",
      jsonData: [],
      income: "",
      incomeAmount: "",
      expenses: "",
      expensesAmount: "",
      space: "",
      branch: "",
      spaceexpenses: "",
      startworkdate:"",
      spaceincome: "",
      data: null,
      period_date: "",
      pdfDocGen: null,
      header_table: [
        {
          text: "#",
        },
        {
          text: "รายการ",
        },
        {
          text: "หน่วยนับ",
        },
        {
          text: "จำนวน",
        },
      ],
    };
  },
  created() {
    this.doc = this.$route.params.docno;
    this.emp_code = this.$route.params.empcode;
    this.getCompany();
  },
  methods: {
    goto(path) {
      this.$router.push("/" + path);
    },
    back() {
      this.goto("payrolldoc/detail/" + this.doc);
    },
    async getPDFByEmpID() {
      let v = this;
      NProgress.start();
      try {
        let tmpResult = await PayrollService.getsilpPayroll(
          this.doc,
          this.emp_code
        );

        // gen items
        let rowIndex = 0;
        var result = [];

        tmpResult.data.forEach((element) => {
          //console.log(element);
          //period_date
          rowIndex++;
          v.code = element.code; //รหัสพนักงาน
          v.name = element.name.split("(")[0]; //ชื่อพนักงาน
          v.date = moment(new Date().toISOString().substr(0, 10)).format("DD/MM/YYYY"); //วันที่
          v.period_date = moment(element.period_date).format("DD/MM/YYYY"); //วันที่
       
          v.departmentname = element.department_name; //ตำแหน่ง
          v.startworkdate = moment(element.startworkdate).format("DD/MM/YYYY"); //
          v.salary = v.thousandSep(element.salary); //เงินเดือน
          v.deductSS = v.thousandSep(element.deductSS); //รายได้สุทธิ
          v.total_balance = v.thousandSep(element.total_balance); //รายได้สุทธิ
          v.accumulatedIncome = v.thousandSep(element.accumulatedIncome); //รายได้สะสม
          v.incomeCraft = element.incomeCraft; //ค่าฝีมือ
          v.incomePosition = element.incomePosition; //ค่าตำแหน่ง
          v.incomeSpecial = element.incomeSpecial; //ค่าพิเศษ
          v.cumulativeSS = v.thousandSep(element.cumulativeSS); //ประกันสะสม
          v.cumulativeTax = v.thousandSep(element.cumulativeTax); //ภาษีสะสม
          v.totalEarning = v.thousandSep(element.totalEarning); //รายได้รวม
          v.totalDeduct = v.thousandSep(element.totalDeduct); //รวมรายจ่าย
          v.incomeAndExpenses = element.incomeAndExpenses; //รวมรายจ่ายและรายได้
          v.deduct_tax = v.thousandSep(element.deduct_tax); //ภาษี
          v.otEarning = element.otEarning; //OT
          v.deductAbsent = element.deductAbsent; //หักเงินขาดรวม
          v.deductLate = element.deductLate; //หักเงินสายรวม
          v.deductOutbefore = element.deductOutbefore; //หักออกก่อนรวม

          v.income = "";
          v.incomeAmount = "";
          v.expenses = "";
          v.expensesAmount = "";
          v.spaceexpenses = "";
          v.spaceincome = "";
          v.space = "";

          if (v.incomeCraft != 0) {
            v.income += `\nค่าฝีมือ`;
            v.incomeAmount += `\n` + v.thousandSep(v.incomeCraft);
            v.spaceincome += `\n`;
          }
          if (v.incomePosition > 0) {
            v.income += `\nค่าตำแหน่ง`;
            v.incomeAmount += `\n` + v.thousandSep(v.incomePosition);
            v.spaceincome += `\n`;
          }
          if (v.incomeSpecial > 0) {
            v.income += `\nค่าพิเศษ`;
            v.incomeAmount += `\n` + v.thousandSep(v.incomeSpecial);
            v.spaceincome += `\n`;
          }
          if (v.otEarning > 0) {
            v.income += `\nค่าทำงานล่วงเวลา`;
            v.incomeAmount += `\n` + v.thousandSep(v.otEarning);
            v.spaceincome += `\n`;
          }
          if (v.deductAbsent > 0) {
            v.expenses += `\nหักเงินขาดรวม`;
            v.expensesAmount += `\n` + v.thousandSep(v.deductAbsent);
            v.spaceexpenses += `\n`;
          }
          if (v.deductLate > 0) {
            v.expenses += `\nหักเงินสายรวม`;
            v.expensesAmount += `\n` + v.thousandSep(v.deductLate);
            v.spaceexpenses += `\n`;
          }
          if (v.deductOutbefore > 0) {
            v.expenses += `\nหักออกก่อนรวม`;
            v.expensesAmount += `\n` + v.thousandSep(v.deductOutbefore);
            v.spaceexpenses += `\n`;
          }
          console.log("-------------------------------");
          if (v.code_emp != v.code) {
            result = [];
          }
          v.incomeAndExpenses.forEach((element) => {
            console.log(element);
            if (result.length > 0) {
              const r = result.filter((el) => el.name == element.name);
              if (r.length == 0) {
                v.nameIAE = {
                  name: element.name,
                  amount: element.amount,
                  tranFlag: element.tranFlag,
                };
                result.push(v.nameIAE);
              } else if (r.length != 0) {
                r[0].amount += element.amount;
              }
            } else {
              v.nameIAE = {
                name: element.name,
                amount: element.amount,
                tranFlag: element.tranFlag,
              };
              result.push(v.nameIAE);
            }
          });
          v.code_emp = v.code;

          for (let index = 0; index < result.length; index++) {
            if (result[index].tranFlag === 0) {
              if (result[index].name) {
              }
              v.income += `\n` + result[index].name;
              v.incomeAmount += `\n` + v.thousandSep(result[index].amount);
              v.spaceincome += `\n`;
            } else if (result[index].tranFlag === 1) {
              v.expenses += `\n` + result[index].name;
              v.expensesAmount += `\n` + v.thousandSep(result[index].amount);
              v.spaceexpenses += `\n`;
            } else if (
              result[index].tranFlag !== 0 &&
              result[index].tranFlag !== 1
            ) {
              v.space += "";
            }
          }

          if (v.deduct_tax !== "0.00") {
            v.expenses += `\nภาษี`;
            v.expensesAmount += `\n` + v.deduct_tax;
            v.spaceexpenses += `\n`;
          }

          if (rowIndex === 1) {
            v.jsonData.push(v.genSlipJson("none"));
          } else {
            v.jsonData.push(v.genSlipJson("before"));
          }
        });
        this.createpdf();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    async getCompany() {
      NProgress.start();
      try {
        let tmpResult = await SettingService.getDataCompany();
        this.ltdName = tmpResult.data.content[0].companyname;
        this.getPDFByEmpID();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    createpdf() {
      let v = this;
      var pdfMake = require("pdfmake/build/pdfmake.js");
      //pdfMake.setFonts(fonts);
      // if (pdfMake.vfs == undefined) {
      //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
      //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // }

      pdfMake.fonts = {
        Sarabun: {
          normal:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
          bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
          italics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
          bolditalics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
        },
      };

      // pdfMake.fonts = {
      //   THSarabunNew: {
      //     normal: "THSarabunNew.ttf",
      //     bold: "THSarabunNew-Bold.ttf",
      //     italics: "THSarabunNew-Italic.ttf",
      //     bolditalics: "THSarabunNew-BoldItalic.ttf",
      //   },
      //   Roboto: {
      //     normal: "Roboto-Regular.ttf",
      //     bold: "Roboto-Medium.ttf",
      //     italics: "Roboto-Italic.ttf",
      //     bolditalics: "Roboto-MediumItalic.ttf",
      //   },
      // };

      let docDefinition = {
        content: this.jsonData,
        styles: {
          header: {
            fontSize: 10,
            bold: true,
            margin: [0, 0, 0, 3],
          },
          subheader: {
            fontSize: 11,
            bold: true,
          },
        },
        defaultStyle: {
          font: "Sarabun",
          fontSize: 9,
        },
      };
      this.pdfDocGen = pdfMake.createPdf(docDefinition);

      this.pdfDocGen.getDataUrl((data) => {
        this.src = data;
      });
    },
    genSlipJson(param) {
      let jSonResult = [
        {
          columns: [
            {
              text: this.ltdName,
              style: "header",
              alignment: "center",
              pageBreak: param,
            },
          ],
        },
        {
          columns: [
            {
              text: "ใบจ่ายเงินเดือน",
              style: "header",
              alignment: "center",
            },
          ],
        },
        {
          columns: [
            {
              text: "รหัสพนักงาน:" + this.code,
              style: "subheader",
              alignment: "left",
            },
          ],
        },
        {
          columns: [
            {
              width: 150,
              table: {
                widths: [70, 70],
                headerRows: 1,
                body: [
                  [
                    {
                      text:
                        "วันที่ : " +
                        this.date +
                        "\n" +
                        "งวดการจ่าย : " +
                        this.period_date +
                        "\n" +
                        "ชื่อ :" +
                        this.name +
                        "\n" +
                        "วันที่เริ่มงาน : " +
                        this.startworkdate +
                    
                        this.spaceincome +
                        "\n\n\n" +
                        this.space +
                        this.spaceexpenses,
                      margin: [0, 0, 0, 15],
                      colSpan: 2,
                    },
                    { text: "" },
                  ],

                  [
                    { text: "รายได้สุทธิ", alignment: "center" },
                    { text: "ผู้รับเงิน", alignment: "center" },
                  ],
                  [
                    { text: this.total_balance, alignment: "center" },
                    { text: "____________", alignment: "center" },
                  ],
                ],
              },
            },
            {
              width: 250,
              margin: [15, 0, 0, 0],
              table: {
                widths: [80, 10, 60, 100, 60],
                headerRows: 1,
                body: [
                  [
                    { text: "รายได้", colSpan: 4, alignment: "center" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    {
                      text:
                        "รายได้รวม" +
                        "\n\n" +
                        this.spaceincome +
                        this.totalEarning,
                      rowSpan: 2,
                      alignment: "center",
                    },
                  ],
                  [
                    { text: "เงินเดือน" + this.income },
                    {
                      text: this.salary + this.incomeAmount + "\n\n",
                      colSpan: 3,
                    },
                  ],
                  [
                    { text: "รายจ่าย", colSpan: 4, alignment: "center" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    {
                      text:
                        "รวมรายจ่าย" +
                        "\n\n" +
                        this.spaceexpenses +
                        this.totalDeduct,
                      rowSpan: 2,
                      alignment: "center",
                    },
                  ],
                  [
                    { text: "ประกันสังคม" + this.expenses },
                    {
                      text: this.deductSS + this.expensesAmount + "\n\n",
                      colSpan: 3,
                    },
                  ],
                  [
                    { text: "รายได้สะสม", colSpan: 2, alignment: "center" },
                    { text: "" },
                    { text: "ภาษีสะสม", alignment: "center" },
                    { text: "เงินประกันสังคมสะสมต่อปี", alignment: "center" },

                    { text: "รายได้สุทธิ", alignment: "center" },
                  ],
                  [
                    {
                      text: this.accumulatedIncome,
                      colSpan: 2,
                      alignment: "center",
                    },
                    { text: "" },
                    { text: this.cumulativeTax, alignment: "center" },
                    { text: this.cumulativeSS, alignment: "center" },

                    { text: this.total_balance, alignment: "center" },
                  ],
                ],
              },
            },
          ],
        },
      ];
      return jSonResult;
    },
  },
};
</script>

<style lang="stylus" scoped>
.print {
  width: 100%;
  height: 100%;

  table {
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }

  table th {
    border-bottom: 1px solid #F2F2F2;
  }
}
</style>
